import React from 'react';
import classnames from 'classnames';

import style from './index.scss';
import SemiCircularBar from '../../../../components/SemiCircularBar';
import { isNull, isEmpty } from 'lodash';
import { fillColorForPredictionLevel } from '../../../../util';
import { refreshAnomalyState } from '../../../../services/tm/investigationDetail';
import { getAlertIDFromURL } from '../../../../services/util';
import EditorModal from './EditorModal';
import { SupervisorReviewWidget } from './SupervisorReviewWidget';
import { AnomalyDispositionWidget } from './AnomalyDispositionWidget';
import {
  getHeaderData,
  getPermissionConfig,
  getRoleOfLoggedInUser
} from './investDetailHeaderUtil';
import AlertPopup from '../../../../components/AlertPopup';
import ConfirmationPopup from '../../../../components/ConfirmationPopup';
import { connect } from 'react-redux';
import { updateAlertDetail } from '../../../../redux/actions/tm/investigationDetail';
import truncate from 'lodash/truncate';

/**
 * HeaderCell
 * @param textLabel
 * @param textValue
 * @returns {*}
 * @constructor
 */
const HeaderCell = ({ textLabel, textValue, isTruncated }) => {
  return (
    <div className={isTruncated ? style.flexTruncatedCell : style.flexCell}>
      <div>{textLabel}</div>
      <strong title={textValue}>{truncate(textValue, { length: 100 })}</strong>
    </div>
  );
};

/**
 * InvestDetailHeader component
 */
class InvestDetailHeader extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);

    this.state = {
      headerAlertDetailObject: {},
      isSuperVisor: false,
      isAnalyst: false,
      supervisorReviewWidgetPerm: {},
      anomalyDispositionWidgetPerm: {},
      analystEditorModalWidgetPerm: {},
      superVisorEditorModalWidgetPerm: {},
      pending: true,
      output: '',
      str_filed: '',
      note: '',
      textNote: '',
      selectedFile: null,
      fileID: null,
      showAlertPopUp: false,
      alertMsg: '',
      showConfirmationPopup: false,
      confirmMsg: '',
      investigationResult: '',
      anomalyStatus: '',
      confirmType: ''
    };
  }

  componentDidMount() {
    const { isSuperVisor, isAnalyst } = getRoleOfLoggedInUser();
    this.setState({ isSuperVisor, isAnalyst });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps?.alertDetail) {
      const { alertStatus } = this.state.headerAlertDetailObject || {};
      const { alertStatus: nextPropStatus } = nextProps.alertDetail || {};
      if (alertStatus) {
        if (nextPropStatus > alertStatus) {
          const { alertDetail } = nextProps;
          this.setState({ headerAlertDetailObject: alertDetail });
        }
      } else {
        const { alertDetail } = nextProps;
        this.setState({ headerAlertDetailObject: alertDetail });
      }
    }
  }

  onAnomalyApproveRejectClick = async (status) => {
    this.setState({ anomalyStatus: status });
    if (status === 'approve') {
      if (this.state.textNote.length === 0) {
        this.toggleAlert('Supervisor notes cannot be empty');
        return;
      }
      this.toggleConfirmation(
        'Are you sure you want to Approve?',
        'anomalyApprove'
      );
    }
    if (status === 'reject') {
      if (this.state.textNote.length === 0) {
        this.toggleAlert('Supervisor notes cannot be empty');
        return;
      }
      this.toggleConfirmation(
        'Are you sure you want to Reject?',
        'anomalyReject'
      );
    }
    localStorage.removeItem('supervisorNote');
  };

  onConfirm = async ({ confirmType }) => {
    switch (confirmType) {
      case 'anomalyDropDown':
        this.submitNote();
        break;
      case 'anomalyApprove':
        this.approveAnomaly();
        break;
      case 'anomalyReject':
        this.rejectAnomaly();
        break;
      default:
        // do nothing bro.
        break;
    }
  };

  onEditorTextSubmit = async (editorHTML, editorText, selectedFile, fileID) => {
    // set Note in State
    this.setState({
      note: editorHTML,
      textNote: editorText,
      selectedFile,
      fileID
    });
    const { isSuperVisor } = this.state;
    const { alertID } = getAlertIDFromURL();
    const payload = { alertID };
    if (isSuperVisor) {
      payload['type'] = 'supervisorWork';
      payload['supervisorNote'] = editorHTML;
    } else {
      payload['type'] = 'analystWork';
      payload['investigatorNote'] = editorHTML;
      if (!isNull(selectedFile) && !isNull(fileID)) {
        payload['attachmentId'] = fileID;
        payload['attachmentName'] = selectedFile.name;
      }
    }
    const headerAlertDetailObject = await refreshAnomalyState(payload);
    this.props.dispatch(updateAlertDetail(headerAlertDetailObject));
    this.setState({ headerAlertDetailObject });
  };

  onReject = () => {
    this.setState({
      showConfirmationPopup: false,
      confirmMsg: '',
      confirmType: ''
    });
  };

  onResolutionDropDownSelection = async (investigationResult) => {
    this.setState({ investigationResult });
    const { textNote } = this.state;
    if (isEmpty(textNote)) {
      this.toggleAlert('Investigator notes cannot be empty');
      return;
    }
    this.toggleConfirmation(
      'Are sure you want to submit the investigation?',
      'anomalyDropDown'
    );
  };

  approveAnomaly = async () => {
    const { alertID } = getAlertIDFromURL();
    const payload = {
      type: 'approve',
      alertID,
      supervisorNote: this.state.note
    };
    const headerAlertDetailObject = await refreshAnomalyState(payload);
    this.props.dispatch(updateAlertDetail(headerAlertDetailObject));
    this.setState({ headerAlertDetailObject });
  };

  rejectAnomaly = async () => {
    const { alertID } = getAlertIDFromURL();
    const payload = {
      type: 'reject',
      alertID,
      supervisorNote: this.state.note
    };
    const headerAlertDetailObject = await refreshAnomalyState(payload);
    this.props.dispatch(updateAlertDetail(headerAlertDetailObject));
    this.setState({ headerAlertDetailObject });
  };

  submitNote = async () => {
    const { alertID } = getAlertIDFromURL();
    const { note, investigationResult } = this.state;
    const payload = {
      type: 'submit',
      alertID,
      investigatorNote: note,
      investigationResult: investigationResult
    };
    const { selectedFile, fileID } = this.state;
    if (!isNull(selectedFile) && !isNull(fileID)) {
      payload['attachmentId'] = fileID;
      payload['attachmentName'] = selectedFile.name;
    }
    const headerAlertDetailObject = await refreshAnomalyState(payload);
    this.props.dispatch(updateAlertDetail(headerAlertDetailObject));
    this.setState({ headerAlertDetailObject });
    localStorage.removeItem('analystNote');
    localStorage.removeItem('supervisorNote');
  };

  /**
   * toggleAlert box
   * @param msg
   * @returns {boolean}
   */
  toggleAlert = (msg = '') => {
    this.setState({
      showAlertPopUp: !this.state.showAlertPopUp,
      alertMsg: msg
    });
    return false;
  };

  toggleConfirmation = (msg, confirmType) => {
    this.setState({
      showConfirmationPopup: !this.state.showConfirmationPopup,
      confirmMsg: msg,
      confirmType: confirmType
    });
    return false;
  };

  renderAlertLevel = (alert_level, alertType) => {
    if (alertType === 'ANOMALY') {
      return <HeaderCell textLabel={'Level:'} textValue={'L3'} />;
    }

    if (alert_level) {
      return <HeaderCell textLabel={'Level:'} textValue={alert_level} />;
    }

    return null;
  };

  renderAlertType = (alertType) => {
    if (alertType) {
      return <HeaderCell textValue={alertType} textLabel={'Alert Type:'} />;
    }
    return <HeaderCell textValue={'NA'} textLabel={'Alert Type:'} />;
  };

  render() {
    const {
      headerAlertDetailObject,
      isSuperVisor,
      isAnalyst,
      supervisorReviewWidgetPerm,
      anomalyDispositionWidgetPerm,
      analystEditorModalWidgetPerm,
      superVisorEditorModalWidgetPerm
    } = this.state;

    let supervisorReviewWidgetPermission = {};
    if (isEmpty(supervisorReviewWidgetPerm)) {
      supervisorReviewWidgetPermission = getPermissionConfig({
        widgetName: 'SupervisorReviewWidget',
        headerAlertDetailObject,
        isSuperVisor,
        isAnalyst
      });
    } else {
      supervisorReviewWidgetPermission = supervisorReviewWidgetPerm;
    }

    let anomalyDispositionWidgetPermission = {};
    if (isEmpty(anomalyDispositionWidgetPerm)) {
      anomalyDispositionWidgetPermission = getPermissionConfig({
        widgetName: 'AnomalyDispositionWidget',
        headerAlertDetailObject,
        isSuperVisor,
        isAnalyst
      });
    } else {
      anomalyDispositionWidgetPermission = analystEditorModalWidgetPerm;
    }

    let analystEditorModalWidgetPermission = {};
    if (isEmpty(analystEditorModalWidgetPerm)) {
      analystEditorModalWidgetPermission = getPermissionConfig({
        widgetName: 'AnalystEditorModalWidget',
        headerAlertDetailObject,
        isSuperVisor,
        isAnalyst
      });
    } else {
      analystEditorModalWidgetPermission = analystEditorModalWidgetPerm;
    }

    let superVisorEditorModalWidgetPermission = {};
    if (isEmpty(superVisorEditorModalWidgetPerm)) {
      superVisorEditorModalWidgetPermission = getPermissionConfig({
        widgetName: 'SuperVisorEditorModalWidget',
        headerAlertDetailObject,
        isSuperVisor,
        isAnalyst
      });
    } else {
      superVisorEditorModalWidgetPermission = superVisorEditorModalWidgetPerm;
    }

    const {
      alert_type,
      alert_level,
      alert_id,
      alertDate,
      score,
      alertStatus,
      rules
    } = getHeaderData(headerAlertDetailObject);

    return (
      <div className={classnames(style.container, style.flexRow)}>
        {this.state.showAlertPopUp && (
          <AlertPopup
            toggleAlert={this.toggleAlert}
            content={this.state.alertMsg}
          />
        )}
        {this.state.showConfirmationPopup && (
          <ConfirmationPopup
            confirmType={this.state.confirmType}
            content={this.state.confirmMsg}
            onReject={this.onReject}
            onAccept={this.onConfirm}
          />
        )}

        {/*START PROGRESS BAR*/}
        <div>
          <SemiCircularBar
            value={score.toFixed(2)}
            color={fillColorForPredictionLevel(alert_type, alert_level)}
            thickness={10}
            min={0}
            max={100}
            text="Score"
            showMin
            showMax
            showText
          />
        </div>
        {/*START PROGRESS BAR*/}

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: 15
          }}>
          <div className={style.alignSelfStart}>
            {this.renderAlertLevel(alert_level, alert_type)}
          </div>

          <div className={style.alignSelfStart}>
            {this.renderAlertType(alert_type)}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}>
          <div className={style.alignSelfStart}>
            <HeaderCell
              isTruncated={true}
              textLabel={'Alert ID:'}
              textValue={alert_id}
            />
          </div>

          <div className={style.alignSelfStart}>
            <HeaderCell textLabel={'Alert Date:'} textValue={alertDate} />
          </div>
        </div>

        <div className={style.alignSelfCenter}>
          <HeaderCell textLabel={'Alert Status:'} textValue={alertStatus} />
        </div>

        {alert_type === 'ALERT' && (
          <div className={style.alignSelfCenter}>
            <div
              className={style.flexCell}
              style={{ flexWrap: 'wrap', width: 500 }}>
              <div>Alert Rules:</div>
              {<strong title={rules}>{rules}</strong>}
            </div>
          </div>
        )}

        {alert_type !== 'ALERT' && (
          <div className={classnames(style.alignSelfCenter, style.minWidth)}>
            <SupervisorReviewWidget
              permissionConfig={supervisorReviewWidgetPermission}
              onAnomalyStatusChange={this.onAnomalyApproveRejectClick}
            />
          </div>
        )}

        {alert_type !== 'ALERT' && (
          <div className={classnames(style.alignSelfCenter, style.minWidth)}>
            <div className={style.flexRow}>
              <AnomalyDispositionWidget
                permissionConfig={anomalyDispositionWidgetPermission}
                headerAlertDetailObject={headerAlertDetailObject}
                onAnomalyResolutionSelection={
                  this.onResolutionDropDownSelection
                }
              />
            </div>
          </div>
        )}

        {alert_type !== 'ALERT' && (
          <div className={classnames(style.alignSelfCenter, style.minWidth)}>
            <EditorModal
              headerAlertDetailObject={headerAlertDetailObject}
              analystEditorModalWidgetPerm={analystEditorModalWidgetPermission}
              superVisorEditorModalWidgetPerm={
                superVisorEditorModalWidgetPermission
              }
              onEditorTextSubmit={this.onEditorTextSubmit}
            />
          </div>
        )}
      </div>
    );
  }
}

/**
 * proptypes
 * @type {{}}
 */
InvestDetailHeader.propTypes = {};

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{investigationDetail: investigationDetail}}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    investigationDetail: state.tmInvestigationDetail
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *, navigateTo: navigateTo}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch,
    updateAlertDetail: (payload) => {
      dispatch(updateAlertDetail(payload));
    }
  };
}

/**
 * connect func  for tmInvestigationDetail page
 */
export default connect(mapStateToProps, mapDispatchToProps)(InvestDetailHeader);
